import { useEffect, useState } from "react";

/** Current time, refreshed every `ms` — for "40 мин назад"-style labels that must tick. */
export function useNow(ms = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), ms);
    return () => window.clearInterval(t);
  }, [ms]);
  return now;
}
